import { PostHogProvider as PostHogReactProvider, usePostHog } from '@posthog/react';
import { useEffect } from 'react';
import type { PropsWithChildren } from 'react';

import { getUserDisplayName, getUserEmail, getUserId } from '@/lib/auth';
import { ensurePostHogInit, isPostHogEnabled } from '@/lib/posthog';
import { useAuth } from '@/providers/useAuth';

function PostHogAuthSync() {
    const posthog = usePostHog();
    const { isReady, isAuthenticated } = useAuth();

    useEffect(() => {
        if (!isPostHogEnabled() || !isReady) {
            return;
        }

        if (!isAuthenticated) {
            posthog.reset();
            return;
        }

        const userId = getUserId();

        if (!userId) {
            return;
        }

        posthog.identify(userId, {
            email: getUserEmail(),
            username: getUserDisplayName()
        });
    }, [isAuthenticated, isReady, posthog]);

    return null;
}

export function PostHogProvider({ children }: PropsWithChildren) {
    if (!isPostHogEnabled()) {
        return children;
    }

    return (
        <PostHogReactProvider client={ensurePostHogInit()}>
            <PostHogAuthSync />
            {children}
        </PostHogReactProvider>
    );
}
